import _lib from '../_lib';
import active from './active/index';
import {AllergyNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'allergies';
  let activations = [
    {
      name: 'allergies',
      test: api.messageIs(AllergyNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};

